import React from 'react';

import { Box, Paper, Typography } from '@mui/material';

import TimelineBody from './TimelineBody';

type Props = {
  parentModelId: string;
  parentModelType: 'WorkflowRun' | 'EmailMessage';
};
export default function ModelTimeline({ parentModelId, parentModelType }: Props) {
  return (
    <Paper>
      <Box p={2}>
        <Typography variant="h5" component="h2">
          Timeline
        </Typography>
        <TimelineBody parentModelId={parentModelId} parentModelType={parentModelType} />
      </Box>
    </Paper>
  );
}
